import { getApiError } from '~/api/problem'
import { formatName } from '~/utils/names'
import { ContactErrorType } from './errors'

type AccessDeniedUser = {
  id: number
  firstname?: string | null
  lastname?: string | null
}

const isUserList = (value: unknown): value is AccessDeniedUser[] =>
  Array.isArray(value) &&
  value.every(
    (user) =>
      typeof user === 'object' && user !== null && typeof user.id === 'number'
  )

/** Wording of a contact access-denied problem (`/errors/contact-access-denied`), naming its followers */
export const contactAccessDeniedMessage = (error: unknown): string => {
  const problem = getApiError(error)
  const users =
    problem?.type === ContactErrorType.AccessDenied
      ? problem.extensions.users
      : undefined
  if (!isUserList(users) || users.length === 0) {
    return "Vous n'avez pas accès à ce contact."
  }
  return `Ce contact est suivi par : ${users.map((user) => formatName(user)).join(', ')}.`
}
